<template>
  <eco-labeled-control
    :context="context"
    :attributes="attributes"
  >
    <div class="value">
      <span>{{ currentValue }}</span>
    </div>
  </eco-labeled-control>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ControlContextV2, EnumDisplayControlAttributes } from './models'

import EcoLabeledControl from './shared/EcoLabeledControl.vue'
  
@Component({
  components: {
    EcoLabeledControl,
  },
})
export default class EcoEnumDisplayControl extends Vue {
  @Prop() public id: string
  @Prop() public context: ControlContextV2
  @Prop() public attributes: EnumDisplayControlAttributes
  @Prop() public state: object

  public get currentValue() {
    const resourceKey = this.attributes.options.find(o => o.id === this.state[this.attributes.state])?.label ?? 'n/a'
    return this.context.resolveStringResource(resourceKey)
  }
}
</script>

<style lang="scss" scoped>
  .value {
    display: flex;
    flex-direction: row;
    padding: 5px 5px;
    line-height: 1.2;
    border-radius: 5px;
    background: rgba(123, 139, 154, 0.1);
    align-self: center;
  }
</style>

<style lang="css">
</style>
